import { CustomerInfo } from 'app/utils/authentication'

export type SendProductRequestFormData = {
  isAuthenticated: boolean
  fullName: string
  email: string
  phoneNumber: string
  description: string
  regionId: number | undefined
}

export const getFormInitialValues = (desription: string, customerInfo: CustomerInfo): SendProductRequestFormData => {
  return {
    isAuthenticated: customerInfo.customer !== null,
    email: customerInfo.customer?.email ?? '',
    phoneNumber: customerInfo.customer?.phoneNumber ?? '',
    fullName: customerInfo.customer?.fullName ?? '',
    description: desription,
    regionId: undefined,
  }
}
